import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import { isMobile } from 'react-device-detect';
import arrowLeftIcon from './images/arrow-left.svg';
//--------------- Swiper ---------------
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper.scss';
SwiperCore.use([Autoplay, Pagination, Navigation]);
//--------------- Swiper ---------------

const DevicesAndAccessories = (props) => {

    const devices = props.iContent.devicesAndAccessories?.expandedValue?.slice(0, 5) || [];
    //console.log('DevicesAndAccessories props:', props);

    return (
        <div className='devices-and-accessories'>
            <div className='devices-title'> {props.iContent.title?.value} </div>

            <div className='devices-wrapper'>
                {
                    isMobile ? (
                        <Swiper centeredSlidesBounds={false} centeredSlides={false} spaceBetween={16} slidesPerView={'auto'} speed={700} setWrapperSize={false} loop={true}>
                            {
                                devices && devices.map((item, index) => (
                                    <SwiperSlide key={index} className='fixed-slide'>
                                        {renderItem(item, index, (!isMobile && index == 0))}
                                    </SwiperSlide>                                                                        
                                ))
                            }                        
                        </Swiper>
                    ) : (
                        <>
                            {
                                devices && devices.map((item, index) => (
                                    renderItem(item, index, (!isMobile && index == 0))
                                ))
                            }                        
                        </>
                    )
                }
            </div>

            {
                props.iContent.allDevicesButtonText?.value &&
                <div className='button-wrapper'>
                    <BtnSubmit text={props.iContent.allDevicesButtonText?.value} onclick={handleOnContinue} className='btn-submit-white' formid='devices-and-accessories-block' />                
                </div>
            }

        </div>
    );

    function renderItem(item, index, isBigItem) {
        return (
            <div key={index} tabindex={index} className={`device-item item${index + 1}${isBigItem ? ' big-item' : ''}`} onClick={() => handleOnItemClick(item.link?.value)}>

                {
                    isMobile && item.bottomTagText?.value &&
                    <div className='mobile-top-tag-wrapper'>
                        <div className='mobile-top-tag' style={{ backgroundColor: item.bottomTagBackgroundColor?.value, color: item.bottomTagTextColor?.value }}>
                            {
                                item.bottomTagIcon?.value?.url &&
                                <span className='mobile-top-tag-icon' style={{ backgroundImage: `url(${Config.epiBaseUrl + item.bottomTagIcon?.value?.url})` }}></span>
                            }                                     
                            {item.bottomTagText?.value}
                        </div> 
                    </div>
                }

                <div className='device-details-wrapper'>
                    {
                        isBigItem && item.topTagText?.value &&
                        <div className='device-top-tag' style={{ backgroundColor: item.topTagBackgroundColor?.value, color: item.topTagTextColor?.value }}> {item.topTagText?.value} </div>
                    }
                    <div className='device-name'> {item.productName?.value} </div>
                    <div className='device-sub-text'> {item.subText?.value} </div>
                    <div className='device-price'> {item.price?.value}<span className='nis'>₪</span> </div>
                    {
                        !isBigItem && item.topTagText?.value &&
                        <div className='device-top-tag' style={{ backgroundColor: item.topTagBackgroundColor?.value, color: item.topTagTextColor?.value }}> {item.topTagText?.value} </div>
                    }                            
                </div>

                <div className='device-image-wrapper'>
                    <Image src={Config.epiBaseUrl + (isMobile ? item.imageMobile?.value?.url : item.imageWeb?.value?.url)} alt={item.productName?.value} />
                </div>

                <div className='device-footer'>
                    {
                        !isMobile && item.bottomTagText?.value &&
                        <div className='device-bottom-tag' style={{ backgroundColor: item.bottomTagBackgroundColor?.value, color: item.bottomTagTextColor?.value }}>
                            {
                                item.bottomTagIcon?.value?.url &&
                                <span className='bottom-tag-icon' style={{ backgroundImage: `url(${Config.epiBaseUrl + item.bottomTagIcon?.value?.url})` }}></span>
                            }                                     
                            {item.bottomTagText?.value}
                        </div>                            
                    }
                    <div className='arrow-icon' style={{backgroundImage:arrowLeftIcon.bg()}}></div>
                </div>

            </div>
        )
    }

    function handleOnItemClick(link) {
        buildUrlAndOpenSameWindow(link);
    }
    
    function handleOnContinue() {
        buildUrlAndOpenSameWindow(props.iContent.allDevicesLink?.value);
    }

};

export default DevicesAndAccessories;
